var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatLineSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49935 9.66668L0.166016 7.33334L0.982682 6.51668L1.91602 7.42084V2.57918L0.982682 3.48334L0.166016 2.66668L2.49935 0.333344L4.83268 2.66668L4.01602 3.48334L3.08268 2.57918V7.42084L4.01602 6.51668L4.83268 7.33334L2.49935 9.66668ZM5.99935 9.08334V7.91668H11.8327V9.08334H5.99935ZM5.99935 5.58334V4.41668H11.8327V5.58334H5.99935ZM5.99935 2.08334V0.916677H11.8327V2.08334H5.99935Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatLineSpacing);
export default __webpack_public_path__ + "static/media/format_line_spacing.94eff677.svg";
export { ForwardRef as ReactComponent };